import { render, staticRenderFns } from "./catalog-tree.vue?vue&type=template&id=5c5a7bca&scoped=true"
import script from "./catalog-tree.vue?vue&type=script&lang=js"
export * from "./catalog-tree.vue?vue&type=script&lang=js"
import style0 from "./catalog-tree.vue?vue&type=style&index=0&id=5c5a7bca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5a7bca",
  null
  
)

export default component.exports